export default __webpack_public_path__ + "static/media/homeBackground.04836c22.jpg";